import { createSlice } from "@reduxjs/toolkit";
import { fetchCommunitySortOrder } from "../actions/communitySortOrderActions";
import { FALLBACK_COMMUNITY_SORT_ORDER } from "../../constants/communitySortOrder";

const initialState = {
  defaultOrderBy: null,
  options: [],
  isLoading: false,
  isLoaded: false,
  error: null,
};

const normalizePayload = (payload) => {
  const options = Array.isArray(payload?.options)
    ? payload.options.filter((option) => option?.order_by && option?.label)
    : [];

  if (!options.length) {
    return {
      defaultOrderBy: FALLBACK_COMMUNITY_SORT_ORDER.defaultOrderBy,
      options: FALLBACK_COMMUNITY_SORT_ORDER.options,
    };
  }

  const defaultOrderBy =
    payload?.default_order_by &&
    options.some((option) => option.order_by === payload.default_order_by)
      ? payload.default_order_by
      : options[0].order_by;

  return { defaultOrderBy, options };
};

const communitySortOrderSlice = createSlice({
  name: "communitySortOrder",
  initialState,
  reducers: {
    clearCommunitySortOrder: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunitySortOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCommunitySortOrder.fulfilled, (state, action) => {
        const { defaultOrderBy, options } = normalizePayload(action.payload);
        state.isLoading = false;
        state.isLoaded = true;
        state.error = null;
        state.defaultOrderBy = defaultOrderBy;
        state.options = options;
      })
      .addCase(fetchCommunitySortOrder.rejected, (state, action) => {
        const { defaultOrderBy, options } = FALLBACK_COMMUNITY_SORT_ORDER;
        state.isLoading = false;
        state.isLoaded = true;
        state.error = action.payload || action.error?.message || null;
        state.defaultOrderBy = defaultOrderBy;
        state.options = options;
      });
  },
});

export const { clearCommunitySortOrder } = communitySortOrderSlice.actions;
export default communitySortOrderSlice.reducer;
